import { FloatingBox } from '../../display/FloatingBox';
import { Colors, Typography } from '../../../theme';
import { isolateComponent, labelStyles, withModifier, } from '@zapier/style-encapsulation';
import { css } from '@emotion/react';
const MENU_ITEM_HEIGHT = 40;
const Styles = labelStyles('FloatingMenu', {
    list: ({ visibleItems }) => [
        {
            maxHeight: ((visibleItems || 0) + 0.5) * MENU_ITEM_HEIGHT + 10,
            overflow: 'auto',
            padding: 10,
        },
    ],
    menuItem: ({ isDisabled, isHighlighted, }) => [
        Object.assign(Object.assign({}, Typography.paragraph3Medium), { alignItems: 'center', borderRadius: 3, cursor: 'pointer', display: 'flex', height: MENU_ITEM_HEIGHT, padding: '0 10px', color: Colors.neutral700 }),
        isDisabled &&
            withModifier('disabled', Object.assign(Object.assign({}, Typography.paragraph3Medium), { color: Colors.neutral500 })),
        isHighlighted &&
            withModifier('enabled-highlighted', Object.assign(Object.assign({}, Typography.paragraph3Medium), { backgroundColor: Colors.blue10, color: Colors.blue })),
    ],
    menuItemIcon: css({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: 10,
    }),
    menuItemText: css({
        flex: 1,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    }),
});
export const FloatingMenu = (_props) => {
    const props = Object.assign({ align: 'stretch', visibleItems: 4 }, _props);
    const { align, ariaLabel, getItemProps, getKeyForItem, getLabelForItem, getMenuProps, highlightedIndex, items, maxWidth, minWidth, } = props;
    return (isolateComponent(FloatingBox, { align: align, maxWidth: maxWidth, minWidth: minWidth },
        isolateComponent("ul", Object.assign({ css: Styles.list(props) }, getMenuProps({ 'aria-label': ariaLabel })), items.map((item, index) => (isolateComponent("li", Object.assign({}, getItemProps({ item, disabled: item.disabled }), { css: Styles.menuItem({
                isDisabled: item.disabled,
                isHighlighted: highlightedIndex === index,
            }), key: getKeyForItem ? getKeyForItem(item) : index }),
            props.renderIcon && (isolateComponent("span", { css: Styles.menuItemIcon }, props.renderIcon(item, props.getLabelForItem))),
            isolateComponent("span", { css: Styles.menuItemText }, getLabelForItem(item))))))));
};
//# sourceMappingURL=FloatingMenu.js.map
// @zapier/design-system@6.3.0 (1dc71580e)
